import { useState } from "react";
import CommCard from "src/common/CommCard";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import VisitorLedgerTable from "./VisitorLedgerTable";
import type { TVisitorLedger } from "./type/reportType";

const VisitorLedger = () => {
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [searchParams, setSearchParams] = useState({ name: "", status: "" });
	const { data, isLoading } = useGetQueryWithTotal<TVisitorLedger[]>({
		endPoint: "/api/admin/reports/visitor-ledger",
		queryKeys: ["visitor-ledger"],
		params: {
			name: searchParams.name,
			status: searchParams.status,
			dateRange,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				showDateRange
				headerTitle='Visitor Ledger List'
				handleSearchFun={(name) =>
					setSearchParams((prev) => ({ ...prev, name }))
				}
				handleDateRange={(date) => {
					setDateRange(date);
				}}
				handleSelectStatus={(status) =>
					setSearchParams((prev) => ({ ...prev, status }))
				}
				helmetTitle='BTTF - Visitor Ledger list'
			>
				<VisitorLedgerTable
					data={data?.data || []}
					isLoading={isLoading}
				/>
			</CommCard>
		</>
	);
};
export default VisitorLedger;
